// (c) chaehongee. Confidential and proprietary.

import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from './hooks'
import { openTab, setActiveTab } from '../slices/sessionTabsSlice'

export function useDeepLinkSessionLoader(): void {
    const dispatch = useAppDispatch()
    const activeSessionId = useAppSelector((s) => s.sessionTabs.activeSessionId)

    useEffect(() => {
        const syncFromPath = () => {
            const path = window.location?.pathname ?? ''
            const match = path.match(/^\/session\/([a-zA-Z0-9-]+)\/?$/)
            if (!match) return

            const sessionId = match[1]
            // Do not trigger hydration here. This hook is responsible only for
            // keeping the active tab in sync with the URL (in-app transition).
            // Hydration is handled by useEnsureActiveSessionHydrated().
            if (activeSessionId !== sessionId) {
                dispatch(openTab(sessionId))
                dispatch(setActiveTab(sessionId))
            }
        }

        syncFromPath()
        window.addEventListener('popstate', syncFromPath)
        return () => window.removeEventListener('popstate', syncFromPath)
    }, [dispatch, activeSessionId])
}


